<app-navBar></app-navBar>
<app-header [message]="$any(['Business Loan','Services','Loans','Business Loans'])"></app-header>
<app-loan-calc-carousel></app-loan-calc-carousel>
<app-loan-calc></app-loan-calc>
<app-footer></app-footer>
